import { muiTheme } from '@tassat/payments-themes';

export default (theme: typeof muiTheme) => ({
    fullWidth: {
        width: '100%',
        alignSelf: 'center' as 'center'
    },
    flexColumn: {
        display: 'flex',
        flexFlow: 'column nowrap'
    },
    blueBackground: {
        marginBottom: '1rem',
        backgroundColor: '#B9D9EC33'
    },
    formSectionDivider: {
        backgroundColor: theme?.app?.applicationColors.enumColors.grey || '#888888',
        marginBottom: '1rem'
    },
    ibnLabelText: {
        color: theme?.app?.applicationColors.enumColors.greyDark || '#333333',
        fontSize: '.9rem',
        paddingLeft: '1rem',
        paddingBottom: '1rem'
    },
    submitButtonContainer: {
        marginTop: '2.5rem',
        marginBottom: '2rem'
    },
    submitButton: { width: 'auto' as 'auto' },
    submitError: { alignSelf: 'center' },
    containerCheckbox: { alignItems: 'flex-start' },
    checkboxField: {
        '& label': {
            width: '35px',
            alignItems: 'center',
            textAlign: 'center',
            minHeight: '1rem'
        },
        '& span': {
            border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#CFCFCF'}`,
            borderRadius: '3px'
        },
        marginRight: '2rem'
    },
    checkboxFieldLong: { marginLeft: '1rem' }
});